import React from "preact/compat";
import { useCallback, useMemo } from "preact/hooks";
import { useEffect, useState } from "react";
import EstateSlideshow from "./EstateSlideshow";
import HtmlContainer from "./HtmlContainer";
import SmartHtmlContainer from "./SmartHmlContainer";

const WidgetFactoryIntern = (props) => {
  const { flow, onEvent, area, isHidden, company, isUniq } = props;
  const type = useMemo(() => area?.widget?.screenType ?? area?.widget?.type ?? 'estate_slideshow', [area]);
  const id = useMemo(() => `test_${flow.id}_${area.slug}_container`, [flow.uniqId, area]);
  const key = useMemo(() => `${flow.id}_${area.slug}_container`, [flow.uniqId, area]);

  useEffect(() => {
    const { area } = props;
    const element = document.getElementById(id);
    let elementJs, elementCss = null

    if (element && !element.textContent?.includes(id)) {
      elementJs = document.createElement('script');
      elementJs.textContent = area?.extraContent?.js ?? ""
      elementJs.textContent = elementJs.textContent.replace(/(<([^>]+)>)/gi, "");
      elementJs.async = true;
      elementJs.onerror = () => {}

      elementCss = document.createElement('style');
      elementCss.textContent = area?.extraContent?.css?.replaceAll(`${area.slug}_container`, id) ?? ""
      elementCss.onerror = () => {}
      element.appendChild(elementJs);
      element.appendChild(elementCss)
    }

    try { window.callPhantom('takeShot'); }
    catch (_) {
      //
    }

    return () => { if (elementJs) element.removeChild(elementJs); if (elementCss) element.removeChild(elementCss); }
  }, []);

  const render_child = useCallback(() => {
    switch (type) {
      case 'estate_playlist':
        return (<EstateSlideshow key={area.id} company={company} isHidden={isHidden} idStorage={key} addEvent={onEvent} area={area} />)
      case 'raw_html':
      case 'weather':
        return (<HtmlContainer key={area.id} area={area} isHidden={isHidden} endOn={flow.endOn} onEvent={onEvent} />)
      case 'react_in_html':
        return (<SmartHtmlContainer key={area.id} isUniq={isUniq} company={company} flow={flow} isHidden={isHidden} idStorage={key} area={area} onEvent={onEvent} />)
      default:
        return <div key={area.id} className={"react-grid-item-intern"}>{props.area.name}</div>
    }
  }, [type]);

  return (
    <div id={id} className={`area_container ${id} `} key={key}>
      {render_child()}
    </div>
  )
}

const WidgetContainer = (props) => {
  const [loading, setLoading] = useState(true);
  const [area, setArea] = useState(props.area)
  const [flow, setFlow] = useState(props.flow)

  useEffect(() => {
    setFlow(props.flow);
    setArea(props.area);
  }, [props.flow.uniqId]);

  useEffect(() => {
    if (area?.data) {
      setLoading(false)
      return;
    } else {
      // Init displayable
    }
  }, []);

  if (loading) return null
  return (<WidgetFactoryIntern {...props} area={area} flow={flow} />)
}

const WidgetFactoryContainer =
  ({ style, className, ...props }) => {
    return (
      <div style={{ height: '100%', width: '100%', ...style }} className={className}>
        <WidgetContainer {...props} />
      </div>
    )
  }

export default React.memo(WidgetFactoryContainer, (props, nextProps) => {
  return props.area?.id === nextProps.area?.id && props.isHidden === nextProps.isHidden
})
